import Excel from "exceljs";
import moment from "moment";

export default function extractDirectSalesData(
  file,
  productData,
  userData,
  selectedDate
) {
  return new Promise(async (resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    let salesDatas = [];
    const startDate = moment(selectedDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    const endDate = moment(selectedDate).endOf("month").format("YYYY-MM-DD");

    reader.onload = () => {
      const buffer = reader.result;
      try {
        wb.xlsx.load(buffer).then(async (workbook) => {
          const salesDataWorkSheet = workbook.getWorksheet(1);
          salesDataWorkSheet.eachRow((row, rowIndex) => {
            if (rowIndex >= 2 && row.values[1]) {
              if (
                !moment(row.values[2]).isBetween(
                  startDate,
                  endDate,
                  "day",
                  "[]"
                )
              ) {
                reject({ message: "dateIsNotCorrect" });
                return false;
              }
              salesDatas.push({
                order_id: row.values[1],
                tx_date: moment(row.values[2]).format("YYYY-MM-DD"),
                user_id: userData[row.values[4]],
                product_id: productData[`${row.values[6]}-1`],
                qty: row.values[8],
                amount: row.values[9],
              });
            }
          });
          resolve(salesDatas);
        });
      } catch (err) {
        console.log(err);

        throw err;
      }
    };
  });
}
